// The icon of each theme preference. One table for the top-bar button and the
// user-menu switcher, so the two never show different pictures for the same
// choice. `monitor` is «whatever the device says».
export const THEME_ICONS = { light: 'sun', dark: 'moon', system: 'monitor' }
